var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[(_vm.includeAbsolute && _vm.absoluteTime)?_c('div',[_vm._v(" "+_vm._s(_vm.absoluteTime)+" ")]):_vm._e(),_c('div',{class:_vm.includeAbsolute && _vm.absoluteTime ? `mt-1 small text-muted` : ``},[_vm._v(" "+_vm._s(_vm.timeSince)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }